import Store from '../store'

export default class Unsubscribe {
  constructor (rawData = {}) {
    this.id = rawData.id
    this.user_id = (rawData.user || {}).id
    this.subscribe_to = rawData.subscribe_to
    this.subscribe_token = rawData.subscribe_token
    this.username = rawData.username
    this.subscription_name = rawData.subscription_name
  }

  toJson (val) {
    try {
      return JSON.parse(val)
    } catch (e) {
      return val
    }
  }


}



// WEBPACK FOOTER //
// ./src/models/UnsubscribeClass.js